<template lang="pug">
  .make-an-entry-water
    .make-an-entry-content
      MakeAnEntryVisibility(text="Always Private")
      section.section.pb-1.pt-2.mt-2
        WtTitle(h4 bold style="margin-bottom:5px") Water
        WtLabel(
          style="color:#756E7A"
          text="How many glasses of water have you had today?"
        )
      .water-section-container
        .water-droplet-and-buttons-container
          BButton.minus-button(v-on:click="watterButtonClick('subtraction')" :disabled="water === 0")
            BIcon.control-icon.minus-icon(icon="minus")
          img.droplet-icon(:src="require(`@/assets/icons/water_droplet_${waterImage > 8 ? 8 : waterImage}.svg`)")
          BButton.plus-button(v-on:click="watterButtonClick('addition')" :disabled="water === 16")
            BIcon.control-icon(icon="plus")
        .number-of-glasses
          .span {{ water }} Glasses
        .glass-description 1 glass = 8oz(25cl)
      MakeAnEntryTip.mx-5(:tip-category="'water'")
    .level.is-mobile.program-settings-form-controls
      .level-left
      .level-right
        .level-item
          WtButton(
            is-text
            color="white"
            style="text-decoration:none"
            size="medium"
            @click.native="reset"
            :disabled="disableReset"
          ) Reset
        .level-item
          WtButton(@click.native="saveEntry" :loading="savingWater" :disabled="disableSave") SAVE
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import MakeAnEntryVisibility from "@@/Members/MakeAnEntry/MakeAnEntryVisibility";

import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtLabel from "@@/WtLabel/WtLabel";
import MakeAnEntryTip from "@@/Members/MakeAnEntry/MakeAnEntryTip";

export default {
  name: "MakeAnEntryWater",

  components: {
    WtLabel,
    WtTitle,
    WtButton,
    MakeAnEntryFooter,
    MakeAnEntryTip,
    MakeAnEntryVisibility
  },

  mixins: [dateUtilityMixin],

  props: {
    uniqueKey: {
      type: String,
      default: null
    },

    fetchAction: {
      type: Function,
      default: () => {},
      required: true
    },

    // "journal" or "discussion"
    type: {
      type: String,
      default: "journal"
    },

    entryItem: {
      type: Object,
      default: () => {},
      required: true
    },

    challengeId: {
      type: Number,
      default: null
    },

    entryDate: {
      type: String,
      default: ""
    },

    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },

    saveEntryWrapper: {
      type: Function,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      water: 0,
      savingWater: false,
      waterImage: 0
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    currentMetricValue() {
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: "water"
      });
      return this._.get(metric, "value", 0);
    },

    setFormData() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.water !== this.currentMetricValue || this.formData.has("water")
        );
      }
      return true;
    }
  },

  watch: {
    water() {
      if (this.setFormData) {
        this.formData.set("water", this.water);
        this.$emit("formDataUpdated", true);
      }
    }
  },

  mounted() {
    this.water = this.currentMetricValue;
    // The metric value can be higher than 8 but water_droplet_8 is the last image, ie full droplet
    this.waterImage = this.water > 8 ? 8 : this.water;
  },

  methods: {
    ...mapActions("members", ["updateJournal", "storeJournal"]),

    saveEntry() {
      this.savingWater = true;
      this.saveEntryWrapper(this.storeJournal, this.updateJournal);
    },

    reset() {
      const item = "water";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      this.water = this.currentMetricValue;
      this.waterImage = this.water > 8 ? 8 : this.water;
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    },

    watterButtonClick(operation) {
      if (operation === "addition" && this.water < 16) {
        this.water += 1;
      }
      if (operation === "subtraction" && this.water > 0) {
        this.water -= 1;
      }
      if (this.water <= 8) {
        this.waterImage = this.water;
      }
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-water
  .water-section-container
    max-width: 200px
  .wellness-visibility
    position: absolute
    right: 1rem
    top: .5rem
  .droplet-icon
    width: 50px
    margin: 0 10px
  .water-droplet-and-buttons-container
    display: flex
    align-items: center
    justify-content: center
  .water-droplet-and-buttons-container button
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
  .control-icon
    display: flex
    align-items: center
    justify-content: center
  .minus-button
    color: $grey-dark
    border-color: $grey-dark
  .plus-button
    border-color: $dodger-blue
    background-color: $dodger-blue
    color: $white
  .number-of-glasses
    display: flex
    align-items: center
    justify-content: center
    padding-top: 15px
    .span
      border: 1px solid $grey
      padding: 0px 10px
      border-radius: 4px
  .glass-description
    text-align: center
    font-weight: 100
    font-size: 12px
    padding-top: 5px
  .program-settings-form-controls
    margin-top: 20px
</style>
